/* istanbul ignore file */
import styled, { keyframes } from 'styled-components';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { InvisibleButton } from 'styles/elements/buttons';
import { CloseIcon } from '@econsult/econsult-ui/dist/assets';
import { Modal } from '@econsult/econsult-ui/dist/components/Modal';
import styles from '@econsult/econsult-ui/dist/styles';
import { rgba } from 'polished';

const { effectStyles } = styles;

const fadeIn = keyframes`
from {
  opacity: 0;
  transform: scale(0.98);
}
to {
  opacity: 1;
  transform: scale(1);
}
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) => theme.paper || '#FFFFFF'};
  padding: 32px;
  border-radius: 12px;
  min-width: 40%;
  max-width: 60%;
  box-shadow: ${({ theme }) => theme.shadow || '0px 4px 10px rgba(0, 0, 0, 0.1)'};
  animation: ${fadeIn} 0.3s ease-in-out;
  opacity: 1;
  backdrop-filter: blur(10px);

  @media (max-width: 480px) {
    width: 90%;
    padding: 24px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSizeHeadingM};
  font-weight: ${({ theme }) => theme.fontWeightBold};
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  margin-bottom: 16px;
`;

export const ModalMessage = styled.p`
  font-size: ${({ theme }) => theme.fontSizeText};
  color: ${({ theme }) => theme.textColorSecondary};
  margin-bottom: 24px;
  line-height: 1.5;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 20px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;

    button {
      width: 100%;
    }
  }
`;

export const CancelButton = styled(Button).attrs({ variant: 'secondary' })`
  background-color: ${({ theme }) => theme.buttonSecondaryBackground || '#E6F0FF'};
  color: ${({ theme }) => theme.buttonSecondaryText || '#004A6E'};
  border: 2px solid ${({ theme }) => theme.buttonSecondaryBorder || 'transparent'};
  min-width: 120px;
  padding: 12px 16px;
  box-sizing: border-box;
  opacity: 1;

  &:hover {
    background-color: ${({ theme }) => theme.buttonSecondaryHover || '#D6E4FF'};
    border-color: ${({ theme }) => theme.buttonSecondaryBorder || '#004A6E'};
    color: ${({ theme }) => theme.buttonSecondaryHoverText || '#003F5C'};
  }
`;

export const ConfirmButton = styled(Button).attrs({ variant: 'primary' })`
  background-color: ${({ theme }) => theme.buttonPrimaryBackground || '#1E194B'};
  color: ${({ theme }) => theme.buttonPrimaryText || '#FFFFFF'};
  border: 2px solid ${({ theme }) => theme.buttonPrimaryBorder || 'transparent'};
  min-width: 120px;
  padding: 12px 16px;
  box-sizing: border-box;

  &:hover {
    background-color: ${({ theme }) => theme.buttonPrimaryHover || '#141137'};
    border-color: ${({ theme }) => theme.buttonPrimaryBorder || '#1E194B'};
  }
`;

export const CloseModalButton = styled(InvisibleButton)`
  color: ${({ theme }) => theme.wrapperModalCloseButton};
  border: 2px solid transparent;
  outline: none;
  padding: 0;
  &:focus {
    border: 2px solid ${({ theme }) => theme.wrapperModalCloseButton};
  }
  &:active {
    outline: none;
  }
`;

export const CloseButtonIcon = styled(CloseIcon)`
  margin-top: 6px;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const StyledConfirmationModal = styled(Modal)``;

export const ConfirmationModalWrapper = styled.div.attrs({ effect: 'TightElevation4' })`
  ${effectStyles};

  max-width: 50vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  background: ${({ theme }) => theme.colorBackgroundSoftWhite};
  border-radius: 0.375rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 1rem;
`;

export const RevertButton = styled(Button).attrs({ size: 'small' })`
  && {
    color: ${({ theme }) => theme.colorActionPrimaryDefault};
    background: ${({ theme }) => theme.colorPrimaryPrimary20};
    border-color: ${({ theme }) => theme.colorPrimaryPrimary20};
    cursor: pointer;
  }
`;

export const MessagingModalConfirmButton = styled(Button).attrs({ size: 'small' })`
  && {
    background: ${({ theme }) => theme.colorStatusError};
    border-color: ${({ theme }) => theme.colorStatusError};
    cursor: pointer;

    &&[disabled] {
      background-color: ${({ theme }) => rgba(theme.colorStatusError, 0.1)} !important;
      color: ${({ theme }) => rgba(theme.colorStatusError, 0.5)} !important;
      border-color: transparent !important;
    }
  }
`;
